<!-- <ngx-spinner
 bdColor = "rgba(0, 0, 0, 0.8)"
  size = "large" color = "#fff"
  type = "ball-scale-multiple"
  [fullScreen] = "true">


<div style="color: white" >

  <img width="150" height="150" src='../../../assets//media/logos/VHP.png'/> <br>

  Loading .  Please Wait .....


</div>

</ngx-spinner> -->

<ngx-spinner
 bdColor = "rgba(0, 0, 0, 0.8)"
  [fullScreen] = "true">
<div style="color: white" >
  <img width="150" height="150" src='../../../assets//media/logos/VHP.png'/> <br>
  Loading .  Please Wait .....
</div>

</ngx-spinner>
  